import SignUp from "@/components/Pages/auth/SignUp.vue";
import Login from "@/components/Pages/auth/Login.vue";
import Dashboard from "@/components/Pages/dashboard/Dashboard.vue";
import Calculation from "@/components/Pages/dashboard/Calculation.vue";
import AboutUs from "@/components/Pages/dashboard/AboutUs.vue";
import pageNotFound from "@/components/Pages/pageNotFound.vue";
import ContactUs from "@/components/Pages/dashboard/ContactUs.vue";
import Blog from "@/components/Pages/dashboard/Blog.vue";

import { createRouter, createWebHistory } from "vue-router";
import PrivacyPolicy from "@/components/Pages/dashboard/privacyPolicy.vue";
import Terms from "@/components/Pages/dashboard/terms.vue";
import BlogDetails from "@/components/views/BlogDetails";

const routes = [
    { name: "Dashboard", component: Dashboard, path: '/', meta: { requiresAuth: false, showAllSections: true  }},
    { name: "Blog", component: Blog, path: '/blog-post', meta: { requiresAuth: false, showAllSections: true  }},
    { name: "Calculation", component: Calculation, path: '/calculation', meta: { requiresAuth: false }},
    { name: "AboutUs", component: AboutUs, path: '/about-us', meta: { requiresAuth: false }},
    { name: "ContactUs", component: ContactUs, path: '/contact-us', meta: { requiresAuth: false }},
    { name: "PrivacyPolicy", component: PrivacyPolicy, path: '/privacy-policy', meta: { requiresAuth: false }},
    { name: "Terms&Condition", component: Terms, path: '/terms-condition', meta: { requiresAuth: false }},
    { name: "Login", component: Login, path: '/login', meta: { guestOnly: false }},
    { name: "SignUp", component: SignUp, path: '/sign-up', meta: { guestOnly: false }},
    { name: "pageNotFound", component: pageNotFound, path: '/page-not-found', meta: { guestOnly: false }},
    {
        path: '/:id',
        name: 'BlogDetails',
        component: BlogDetails,
        // component: () => import('@/components/views/BlogDetails')
    },
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: pageNotFound }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach((to, from, next) => {
    const isAuthenticated = !!localStorage.getItem('auth');  // Check if user is logged in

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            next({ name: 'Login' });
        } else {
            next();
        }
    } else if (to.matched.some(record => record.meta.guestOnly)) {
        if (isAuthenticated) {
            next({ name: 'Dashboard' });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
